import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import TaskTable from "./TaskTable";
import axios from "axios";
import { SUBMIT_TO_DO_TASKS } from "../../constants";
import { useNavigate } from "react-router-dom";

const BdmListofTasks = ({
  open,
  onClose,
  initialHoTask,
  setInitialHoTask,
  initialSelfTask,
  setInitialSelfTask,
}) => {
  const storedId = localStorage.getItem("username");
  const userData = localStorage.getItem("userData");
  const storedName = userData ? JSON.parse(userData).EmployeeName : null;

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // State for "Other Tasks"
  const [otherTasks, setOtherTasks] = useState([]);
  const [selectedOtherTask, setSelectedOtherTask] = useState("");
  const [remark, setRemark] = useState("");
  const [error, setError] = useState("");

  // Handle adding "Other Tasks"
  const handleAddTask = () => {
    if (selectedOtherTask && remark) {
      const newTask = {
        id: new Date().getTime(),
        task_name: selectedOtherTask,
        remarks: remark,
      };

      setOtherTasks((prevTasks) => [newTask, ...prevTasks]); // Add new task to the list
      setSelectedOtherTask(""); // Clear the selected task
      setRemark(""); // Clear the remark
      setError(""); // Clear any errors
    } else {
      setError("Please select a task and enter a remark."); // Show error if fields are empty
    }
  };

  const allRequiredTasksHandled = () => {
    const allTasks = [...initialHoTask, ...initialSelfTask]; // Combine both task sections
    return allTasks.every((task) => task.confirmed || task.postponedDate);
  };

  // const handleSubmitActions = async () => {
  //   // setLoading(true);
  //   const HOActions = [];
  //   const selfActions = [];
  //   const otherTaskActions = [];

  //   taskSections.forEach((section) => {
  //     section.tasks.forEach((task) => {
  //       if (task.confirmed) {
  //         const action = {
  //           id: task.id,
  //           action_type: "confirm",
  //           specific_action: task.bdm_remark || "No remarks",
  //           remarks: "No remarks",
  //         };
  //         if (task.isSelfTask) {
  //           selfActions.push(action);
  //         } else {
  //           HOActions.push(action);
  //         }
  //       } else if (task.postponedDate) {
  //         const postponedDate = new Date(task.postponedDate);
  //         const adjustedDate = new Date(postponedDate);
  //         adjustedDate.setDate(adjustedDate.getDate() + 1); // Add one day

  //         const postponedAction = {
  //           id: task.id,
  //           action_type: "postpone",
  //           new_follow_up_date: adjustedDate.toISOString(), // Use ISO string format
  //           remarks: task.postponedRemark,
  //         };
  //         if (task.isSelfTask) {
  //           selfActions.push(postponedAction);
  //         } else {
  //           HOActions.push(postponedAction);
  //         }
  //       }
  //     });
  //   });

  //   otherTasks.forEach((task) => {
  //     otherTaskActions.push({
  //       task_name: task.task_name,
  //       remarks: task.remarks,
  //     });
  //   });

  //   if (selectedOtherTask && remark) {
  //     otherTaskActions.push({
  //       task_name: selectedOtherTask,
  //       remarks: remark,
  //     });
  //   }

  //   const payload = {
  //     bdmId: storedId,
  //     HO_task: HOActions,
  //     self_task: selfActions,
  //     other_task: otherTaskActions,
  //     attendanceType: "IN",
  //     latitude: 12.9716,
  //     longitude: 77.5946,
  //   };

  //   try {
  //     const response = await fetch(`${BASE_URL}/batch-lead-actions`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(payload),
  //     });

  //     if (!response.ok) {
  //       const errorData = await response.json();
  //       throw new Error(errorData.message || "Network response was not ok");
  //     }

  //     const result = await response.json();
  //     console.log("Success:", result);
  //     setOtherTasks([]); // Clear other tasks on success
  //     setRemark(""); // Clear remark input
  //     onClose(); // Close modal on success
  //   } catch (error) {
  //     console.error("Error submitting actions:", error);
  //     setError(error.message); // Display the error message
  //   } finally {
  //     setLoading(false); // Reset loading state
  //   }

  //   // navigator.geolocation.getCurrentPosition(
  //   //   async (position) => {
  //   //     const { latitude, longitude } = position.coords;

  //   //     console.log('latitude',latitude);
  //   //     console.log('longitude',longitude);

  //   //     const payload = {
  //   //       bdmId: storedId,
  //   //       HO_task: HOActions,
  //   //       self_task: selfActions,
  //   //       other_task: otherTaskActions,
  //   //       attendanceType: "IN",
  //   //       latitude,
  //   //       longitude,
  //   //     };

  //   //     try {
  //   //       const response = await fetch(`${BASE_URL}/batch-lead-actions`, {
  //   //         method: "POST",
  //   //         headers: {
  //   //           "Content-Type": "application/json",
  //   //         },
  //   //         body: JSON.stringify(payload),
  //   //       });

  //   //       if (!response.ok) {
  //   //         const errorData = await response.json();
  //   //         throw new Error(errorData.message || "Network response was not ok");
  //   //       }

  //   //       const result = await response.json();
  //   //       console.log("Success:", result);
  //   //       setOtherTasks([]); // Clear other tasks on success
  //   //       setRemark(""); // Clear remark input
  //   //       navigate('/bdmtodo');
  //   //       onClose(); // Close modal on success
  //   //     } catch (error) {
  //   //       console.error("Error submitting actions:", error);
  //   //       setError(error.message); // Display the error message
  //   //     } finally {
  //   //       setLoading(false); // Reset loading state
  //   //     }
  //   //   },
  //   //   (error) => {
  //   //     // console.error("Error fetching location:", error.message);
  //   //     setError("Unable to fetch location. Please enable location access.");
  //   //     setLoading(false); // Reset loading state even on error
  //   //   },
  //   //   {
  //   //     enableHighAccuracy: true,
  //   //     timeout: 5000,
  //   //     maximumAge: 0,
  //   //   }
  //   // );
  // };

  const getLocation = () => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            });
          },
          (error) => {
            console.error("Error getting location:", error);
            resolve({ latitude: 12.9716, longitude: 77.5946 }); // Default fallback (Bangalore)
          }
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
        resolve({ latitude: 12.9716, longitude: 77.5946 }); // Default fallback
      }
    });
  };

  const handleSubmitActions = async () => {
    setLoading(true); // Set loading state
    const HOActions = [];
    const selfActions = [];
    const otherTaskActions = [];

    // Process HO Tasks
    initialHoTask.forEach((task) => {
      if (task.confirmed) {
        const baseTask = {
          id: task.id,
          action_type: "confirm",
          specific_action: task.bdm_remark || "No remarks",
          remarks: "No remarks",
        };
    
        if (task.bdm_remark === "Meeting_Office") {
          baseTask.selectedTaskLocation = task.selectedTaskLocation;
          baseTask.branchOffice =
            task.selectedTaskLocation === "bo" ? task.branchOffice : null;
          baseTask.regionalOffice =
            task.selectedTaskLocation === "ro" ? task.regionalOffice : null;
        }
    
        HOActions.push(baseTask);
      } else if (task.postponedDate) {
        const postponedDate = new Date(task.postponedDate);
        postponedDate.setDate(postponedDate.getDate() + 1);
    
        HOActions.push({
          id: task.id,
          action_type: "postpone",
          new_follow_up_date: postponedDate.toISOString(),
          remarks: task.postponedRemark || "No remarks",
        });
      }
    });

    // Process Self Tasks
    initialSelfTask.forEach((task) => {
      if (task.confirmed) {
        const baseTask = {
          id: task.id,
          action_type: "confirm",
          specific_action: task.bdm_remark || "No remarks",
          remarks: "No remarks",
        };
    
        if (task.bdm_remark === "Meeting_Office") {
          baseTask.selectedTaskLocation = task.selectedTaskLocation;
          baseTask.branchOffice =
            task.selectedTaskLocation === "bo" ? task.branchOffice : null;
          baseTask.regionalOffice =
            task.selectedTaskLocation === "ro" ? task.regionalOffice : null;
        }
    
        selfActions.push(baseTask);
      } else if (task.postponedDate) {
        const postponedDate = new Date(task.postponedDate);
        postponedDate.setDate(postponedDate.getDate() + 1);
    
        selfActions.push({
          id: task.id,
          action_type: "postpone",
          new_follow_up_date: postponedDate.toISOString(),
          remarks: task.postponedRemark || "No remarks",
        });
      }
    });
    

    // Process Other Tasks
    otherTasks.forEach((task) => {
      otherTaskActions.push({
        task_name: task.task_name,
        remarks: task.remarks,
        action_type:  ["HO Visit", "RO Visit", "Expo Event",  "BO Visit", "Travel"].includes(task.task_name) ? "confirm" : null,
        specific_action: task.task_name,
      });
    });

    // Include new "Other Task" if provided
    if (selectedOtherTask && remark) {
      otherTaskActions.push({
        task_name: selectedOtherTask,
        remarks: remark,
        action_type:  ["HO Visit", "RO Visit", "Expo Event",  "BO Visit", "Travel"].includes(selectedOtherTask) ? "confirm" : null,
        specific_action: selectedOtherTask,
      });
    }

    // **Validation: Ensure at least one task in 'Other Tasks' if HO and Self are empty**
    if (
      HOActions.length === 0 &&
      selfActions.length === 0 &&
      otherTaskActions.length === 0
    ) {
      setLoading(false);
      setError("Please select a Task.");
      return;
    }

    try {
      const { latitude, longitude } = await getLocation(); // Fetch user's location

      // Prepare Payload
      const payload = {
        bdmId: storedId,
        HO_task: HOActions,
        self_task: selfActions,
        other_task: otherTaskActions,
        attendanceType: "IN",
        latitude, // Dynamically obtained
        longitude, // Dynamically obtained
      };

      const response = await axios.post(`${SUBMIT_TO_DO_TASKS}`, payload);
      const { data } = response.data;
      console.log("Success:", data);

      // Reset states on success
      setOtherTasks([]);
      setRemark("");
      setSelectedOtherTask("");
      onClose();
      navigate("/bdmtodo");
    } catch (error) {
      console.error("Error submitting actions:", error);
      setError(error.message); // Display error message
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} fullScreen>
        <DialogTitle>Today List of {storedName} </DialogTitle>
        <DialogContent>
          <div className="mb-4">
            <Typography variant="h5" sx={{ fontWeight: 700 }}>
              HO Task
            </Typography>
            <TaskTable
              tasks={initialHoTask}
              setTaskSections={setInitialHoTask}
            />
          </div>

          <div className="mb-4">
            <Typography variant="h5" sx={{ fontWeight: 700 }}>
              Self Task
            </Typography>
            <TaskTable
              tasks={initialSelfTask}
              setTaskSections={setInitialSelfTask}
            />
          </div>

          {/* Other Task Section */}
          <div className="mt-6">
            <Typography variant="h5" sx={{ fontWeight: 700 }}>
              Other Task
            </Typography>

            {/* Display Existing Other Tasks */}
            {otherTasks.length > 0 && (
              <div className="mt-4">
                <ul>
                  {otherTasks.map((task) => (
                    <li key={task.id}>
                      <Typography>
                        <strong>{task.task_name}</strong> - {task.remarks}
                      </Typography>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Add New Other Task */}
            <Grid container spacing={2} alignItems="center" className="mt-4">
              <Grid item xs={6}>
                <FormControl fullWidth error={!!error}>
                  <InputLabel>Select Other Task</InputLabel>
                  <Select
                    value={selectedOtherTask}
                    onChange={(e) => setSelectedOtherTask(e.target.value)}
                    label="Select Other Task"
                  >
                    <MenuItem value="">Select Task</MenuItem>
                    <MenuItem value="Agreement">Agreement</MenuItem>
                    {/* <MenuItem value="Customer Creation">
                      Customer Creation
                    </MenuItem>
                    <MenuItem value="Dispatch Planning">
                      Dispatch Planning
                    </MenuItem>
                    <MenuItem value="Installation Planning">
                      Installation Planning
                    </MenuItem> */}
                    <MenuItem value="Complaint/ Service">
                      Complaint/ Service
                    </MenuItem>
                    {/* <MenuItem value="Consent 3rd Party">
                      Consent 3rd Party
                    </MenuItem> */}
                    <MenuItem value="HO Visit">HO Visit</MenuItem>
                    <MenuItem value="RO Visit">RO Visit</MenuItem>
                    <MenuItem value="BO Visit">BO Visit</MenuItem>
                    <MenuItem value="Expo Event">Expo Event</MenuItem>
                    <MenuItem value="Travel">Travel</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                  {error && (
                    <Typography color="error" variant="body2">
                      {error}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Remark"
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                  fullWidth
                  error={!!error}
                />
              </Grid>

              <Grid item xs={2}>
                <Button
                  onClick={handleAddTask}
                  variant="contained"
                  color="primary"
                  fullWidth
                >
                  +
                </Button>
              </Grid>
            </Grid>
          </div>
        </DialogContent>
        <DialogActions>
          {loading ? (
            <CircularProgress />
          ) : (
            <>
              <Button
                onClick={handleSubmitActions}
                style={{
                  border: `2px solid ${
                    !allRequiredTasksHandled() || loading ? "gray" : "green"
                  }`, // Change border color based on disabled state
                  backgroundColor: "white",
                  color: "green",
                  padding: "10px 20px",
                  borderRadius: "5px",
                  cursor:
                    !allRequiredTasksHandled() || loading
                      ? "not-allowed"
                      : "pointer",
                  transition: "background-color 0.3s, color 0.3s",
                  opacity: !allRequiredTasksHandled() || loading ? 0.6 : 1,
                }}
                disabled={!allRequiredTasksHandled() || loading}
                onMouseEnter={(e) => {
                  if (!(!allRequiredTasksHandled() || loading)) {
                    e.currentTarget.style.backgroundColor = "green";
                    e.currentTarget.style.color = "white";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!(!allRequiredTasksHandled() || loading)) {
                    e.currentTarget.style.backgroundColor = "white";
                    e.currentTarget.style.color = "green";
                  }
                }}
              >
                Attendance IN
              </Button>
            </>
          )}
          <Button onClick={onClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default BdmListofTasks;
